"use client";

import { c as _c } from "react/compiler-runtime";
import { useModalSequence } from "@/providers/modal-sequence";
import { useCallback } from "react";
export function useRelationshipSelection() {
  const $ = _c(8);
  const {
    isRelationshipModalActive,
    completeRelationshipModal
  } = useModalSequence();
  let t0;
  if ($[0] !== completeRelationshipModal) {
    t0 = () => {
      completeRelationshipModal();
    };
    $[0] = completeRelationshipModal;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const markSelectionShown = t0;
  let t1;
  if ($[2] !== completeRelationshipModal) {
    t1 = () => {
      completeRelationshipModal();
    };
    $[2] = completeRelationshipModal;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const hideSelection = t1;
  let t2;
  if ($[4] !== hideSelection || $[5] !== isRelationshipModalActive || $[6] !== markSelectionShown) {
    t2 = {
      shouldShowSelection: isRelationshipModalActive,
      markSelectionShown,
      hideSelection
    };
    $[4] = hideSelection;
    $[5] = isRelationshipModalActive;
    $[6] = markSelectionShown;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}